import * as i0 from '@angular/core';
import * as i1 from './dialog.module';
import * as i2 from '@angular/common';
import * as i3 from '../icon/static-icon.component';
import * as i4 from '../placeholder/placeholder.component';
import * as i5 from './dialog.component';
import * as i6 from './tooltip/tooltip.component';
import * as i7 from './overflow-menu/overflow-menu.component';
import * as i8 from './overflow-menu/overflow-menu-pane.component';
import * as i9 from './dialog.directive';
import * as i10 from './tooltip/tooltip.directive';
import * as i11 from './tooltip/ellipsis-tooltip.directive';
import * as i12 from './overflow-menu/overflow-menu.directive';
import * as i13 from './overflow-menu/overflow-menu-option.component';
import * as i14 from './dialog-placeholder.component';
import * as i15 from '../icon/static-icon.module';
import * as i16 from '../i18n/i18n.module';
import * as i17 from '../placeholder/placeholder.module';
export const DialogModuleNgFactory:i0.NgModuleFactory<i1.DialogModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any> = (<any>(null as any));
var _decl0_3:i2.NgIf = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.StaticIcon = (<any>(null as any));
var _decl0_12:i4.Placeholder = (<any>(null as any));
var _decl0_13:i5.Dialog = (<any>(null as any));
var _decl0_14:i6.Tooltip = (<any>(null as any));
var _decl0_15:i7.OverflowMenu = (<any>(null as any));
var _decl0_16:i8.OverflowMenuPane = (<any>(null as any));
var _decl0_17:i9.DialogDirective = (<any>(null as any));
var _decl0_18:i10.TooltipDirective = (<any>(null as any));
var _decl0_19:i11.EllipsisTooltip = (<any>(null as any));
var _decl0_20:i12.OverflowMenuDirective = (<any>(null as any));
var _decl0_21:i13.OverflowMenuOption = (<any>(null as any));
var _decl0_22:i14.DialogPlaceholder = (<any>(null as any));
var _decl0_23:i2.AsyncPipe = (<any>(null as any));
var _decl0_24:i2.UpperCasePipe = (<any>(null as any));
var _decl0_25:i2.LowerCasePipe = (<any>(null as any));
var _decl0_26:i2.JsonPipe = (<any>(null as any));
var _decl0_27:i2.SlicePipe = (<any>(null as any));
var _decl0_28:i2.DecimalPipe = (<any>(null as any));
var _decl0_29:i2.PercentPipe = (<any>(null as any));
var _decl0_30:i2.TitleCasePipe = (<any>(null as any));
var _decl0_31:i2.CurrencyPipe = (<any>(null as any));
var _decl0_32:i2.DatePipe = (<any>(null as any));
var _decl0_33:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_34:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_35:i2.KeyValuePipe = (<any>(null as any));
var _decl0_36:i2.CommonModule = (<any>(null as any));
var _decl0_37:i15.StaticIconModule = (<any>(null as any));
var _decl0_38:i16.I18nModule = (<any>(null as any));
var _decl0_39:i17.PlaceholderModule = (<any>(null as any));
var _decl0_40:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_41:i0.ElementRef<any> = (<any>(null as any));
function _View_Dialog_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_Dialog_1_0():void {
  var _any:any = (null as any);
}
function _View_Tooltip_Host_2_0():void {
  var _any:any = (null as any);
}
function _View_Tooltip_2_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_14.dialogConfig.compID;
  currVal_0;
  const currVal_1:any = _decl0_14.hasContentTemplate;
  currVal_1;
  const currVal_2:any = !_decl0_14.hasContentTemplate;
  currVal_2;
}
function _View_OverflowMenu_Host_3_0():void {
  var _any:any = (null as any);
}
function _View_OverflowMenu_3_0():void {
  var _any:any = (null as any);
  const currVal_0:any = 'bx--overflow-menu';
  currVal_0;
  const currVal_1:any = (<any>{'bx--overflow-menu--open':(_decl0_15.open === true)});
  currVal_1;
  const currVal_2:any = 'bottom';
  currVal_2;
  const currVal_3:any = _any;
  currVal_3;
  const currVal_4:any = _decl0_15.flip;
  currVal_4;
  const currVal_5:any = _decl0_15.buttonLabel;
  currVal_5;
}
function _View_OverflowMenuPane_Host_4_0():void {
  var _any:any = (null as any);
}
function _View_OverflowMenuPane_4_0():void {
  var _any:any = (null as any);
  const currVal_0:any = 'bx--overflow-menu-options bx--overflow-menu-options--open';
  currVal_0;
  const currVal_1:any = (<any>{'bx--overflow-menu--flip':_decl0_16.dialogConfig.flip});
  currVal_1;
  const currVal_2:any = _decl0_16.dialogConfig.menuLabel;
  currVal_2;
  const currVal_3:any = _decl0_16.dialogConfig.menuLabel;
  currVal_3;
  const currVal_4:any = (<any>{overflowMenu:_decl0_16});
  currVal_4;
  const currVal_5:any = _decl0_16.dialogConfig.content;
  currVal_5;
  const pd_6:any = ((<any>_decl0_16.clickClose(_any)) !== false);
}
function _View_OverflowMenuOption_Host_5_0():void {
  var _any:any = (null as any);
}
function _View_OverflowMenuOption_5_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_21.tabIndex;
  currVal_0;
  const currVal_1:any = _decl0_21.disabled;
  currVal_1;
  const currVal_2:any = (_decl0_21.titleEnabled? _decl0_21.content: '');
  currVal_2;
  const pd_3:any = ((<any>(_decl0_21.tabIndex = 0)) !== false);
  const pd_4:any = ((<any>(_decl0_21.tabIndex = (0 - 1))) !== false);
}
function _View_DialogPlaceholder_Host_6_0():void {
  var _any:any = (null as any);
}
function _View_DialogPlaceholder_6_0():void {
  var _any:any = (null as any);
}
